import { css } from '@emotion/react'
import { Component } from 'react'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'

import { Button, Spacer, SharedModal, Loading } from '../../../components'

const ButtonsBox = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  max-width: 680px;
  width: 100%;

  @media (max-width: 800px) {
    flex-wrap: wrap;
    flex-direction: column-reverse;
    margin: 0;
  }
`

const ButtonSpacer = styled.div`
  flex-grow: 1;
`
const ButtonWrapper = styled.div`
  margin: 0px 20px;
`
const DeleteText = styled.div`
  color: ${p => p.theme.mediumGray};
  font-size: 24px;
  line-height: 33px;
`

class DashboardDeleteAccount extends Component {
  static propTypes = {
    isModalOpen: PropTypes.bool,
    toggleModal: PropTypes.func,
    title: PropTypes.string,
    handleConfirmation: PropTypes.func,
    loading: PropTypes.bool,
  }

  render() {
    const {
      handleConfirmation,
      isModalOpen,
      toggleModal,
      title = 'Delete account',
      loading,
      error,
    } = this.props

    return (
      <SharedModal isModalOpen={isModalOpen} title={title} toggleModal={toggleModal}>
        <DeleteText>
          <p>Are you sure?</p>
          <Spacer space='6px' />
          <p> This action can't be undone.</p>
        </DeleteText>
        {error && (
          <div
            css={css`
              color: #e31e27;
              font-size: 14px;
              line-height: 1.5;
              text-align: center;
              padding: 0.25rem 0 0.75rem 0;
            `}>
            Something went wrong, please try again later.
          </div>
        )}
        {loading ? (
          <Loading />
        ) : (
          <ButtonsBox>
            <ButtonWrapper>
              <Button secondary label='Cancel' onClick={toggleModal} width='85px' />
            </ButtonWrapper>
            <ButtonSpacer />
            <ButtonWrapper>
              <Button primary label='Yes' onClick={handleConfirmation} width='85px' />
            </ButtonWrapper>
          </ButtonsBox>
        )}
      </SharedModal>
    )
  }
}

export default DashboardDeleteAccount
